<template>
  <button
    class="relative py-2 transition-all duration-300 text-lg"
    :class="[{ 'cursor-not-allowed opacity-75': props.disabled }, {'font-semibold': props.selected}]"
  >
    {{ props.title }}
    <span
      class="absolute left-0 bottom-0 w-full h-0.5 transform scale-x-0 transition-transform duration-300 ease-out bg-primary-500"
      :class="{ 'scale-x-100': props.selected }"
    ></span>
  </button>
</template>

<script setup>
  const props = defineProps({
    title: String,
    selected: Boolean,
    disabled: Boolean,
  })
</script>
